import React, { Dispatch, SetStateAction, useState } from 'react'
import styled from 'styled-components'
import { Choice } from '.'
import { Box } from '../../../UI/Box'
import CustomCheckbox from '../../../../page_components/Account/CustomCheckbox'

type FormSelectInputProps = {
  options: Choice[]
  isMultipleSelect: boolean
  selectedOptions: string[]
  setSelectedOptions: Dispatch<SetStateAction<string[]>>
}

const ChoiceWrapper = styled(Box)`
  width: calc(100% - 1rem);
  padding: 0.5rem 1rem;
  gap: 2rem;
  min-height: 40px;
  border: 1px solid #ffffff14;
  background: #030b11;
  border-radius: 12px;
  span.title {
    leading-trim: both;
    text-edge: cap;
    color: ${({ theme }) => theme.colors.onSecondaryContainer};
    font-feature-settings: 'ss01' on;
    font-size: 16px;
    font-style: normal;
    font-weight: 900;
    line-height: 20px; /* 125% */
    letter-spacing: 0.16px;
  }
  strong {
    font-weight: 900;
  }
  @media screen and (max-width: ${({ theme }) =>
      theme.layout.compact.maxWidth}px) {
    gap: 1rem;
    width: calc(50% - 1rem);
    font-size: 14px;
  }
  :hover {
    cursor: pointer;
  }
`

const CheckWrapper = styled(Box)`
  width: 40%;
  @media screen and (max-width: ${({ theme }) =>
      theme.layout.compact.maxWidth}px) {
    width: 100%;
  }
`

const FormSelectInput: React.FC<FormSelectInputProps> = ({
  options,
  isMultipleSelect,
  selectedOptions,
  setSelectedOptions,
}) => {
  const handleOptionSelect = (optionId: string) => {
    if (!isMultipleSelect) {
      setSelectedOptions(selectedOptions?.[0] === optionId ? [] : [optionId])
      return
    }
    if (!selectedOptions.includes(optionId)) {
      setSelectedOptions([...selectedOptions, optionId])
      return
    }
    setSelectedOptions(selectedOptions.filter((id) => id !== optionId))
  }


  return (
    <CheckWrapper gap={20} direction="column">
      {options.map(({ id, text }) => (
        <Box key={id} onClick={() => handleOptionSelect(id)}>
          <ChoiceInput
            option={text}
            isSelected={selectedOptions.includes(id)}
          />
        </Box>
      ))}
    </CheckWrapper>
  )
}

function ChoiceInput({
  option,
  isSelected,
}: {
  option: string
  isSelected: boolean
}) {
  return (
    <ChoiceWrapper jsb>
      <span className="title">{option}</span>
      <CustomCheckbox isSelected={isSelected} />
    </ChoiceWrapper>
  )
}

export default FormSelectInput
